import { PageBuilderWidgetModel } from "@de-trustleap/shared-models";

export function applyStyles(
    element: HTMLElement,
    widget: PageBuilderWidgetModel,
    extraStyles: { [key: string]: string | number } = {}
) {
    const styleObject: { [key: string]: string | number } = {
        paddingTop: `${widget.padding?.top ?? 0}px`,
        paddingRight: `${widget.padding?.right ?? 0}px`,
        paddingBottom: `${widget.padding?.bottom ?? 0}px`,
        paddingLeft: `${widget.padding?.left ?? 0}px`,
        marginTop: `${widget.margin?.top ?? 0}px`,
        marginRight: `${widget.margin?.right ?? 0}px`,
        marginBottom: `${widget.margin?.bottom ?? 0}px`,
        marginLeft: `${widget.margin?.left ?? 0}px`,
        ...extraStyles
    };

    Object.entries(styleObject).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            const cssKey = key.replace(/([A-Z])/g, "-$1").toLowerCase();
            element.style.setProperty(cssKey, value.toString());
        }
    });
}
